<div class="cm-login-container">
    <div class="cm-login-card">
        @if ($isVerifying()) {
            <div class="cm-login-card-header">Verifying your email...</div>
            <mat-progress-spinner mode="indeterminate" [diameter]="24" color="primary"></mat-progress-spinner>
        } @else if ($verificationSuccess()) {
            <div class="cm-login-card-header">
                <i class="far fa-check-circle cm-success-icon"></i>
                Email Verified!
            </div>
            <div class="cm-login-form">
                <div class="cm-verification-message">Your email has been successfully verified. Redirecting you to the platform...</div>
            </div>
        } @else if ($errorMessage()) {
            <div class="cm-login-card-header">
                <i class="far fa-times-circle cm-error-icon"></i>
                Verification Failed
            </div>
            <div class="cm-login-form">
                <div class="cm-verification-message">{{ $errorMessage() }}</div>
                <a class="cm-reset-password" [routerLink]="['/95ngsj3e/sign-up']">Return to Sign Up</a>
            </div>
        }
    </div>
</div>
